import { Component, EventEmitter, Input, OnInit, Output } from "@angular/core";
import { Camera } from "@capacitor/camera";
import { Platform } from "@ionic/angular";
import { ParseFile } from "src/app/services/parse-file";

@Component({
  selector: "app-upload-multiple-box",
  templateUrl: "./upload-multiple-box.component.html",
  styleUrls: ["./upload-multiple-box.component.scss"],
})
export class UploadMultipleBoxComponent implements OnInit {
  @Input() text: string;

  @Output("onFileUploaded")
  private eventFileUpload: EventEmitter<ParseFile> =
    new EventEmitter<ParseFile>();

  public parseFile: any = [];
  public isUploading: boolean = false;
  public selectedCount: number = 0;

  constructor(
    private platform: Platform,
    private parseFileService: ParseFile
  ) {}

  ngOnInit() {}

  async onSelectImages() {
    if (this.isUploading) return;

    try {
      // Check and request permissions first
      const permissionStatus = await Camera.checkPermissions();
      console.log("Permission status:", permissionStatus);

      if (
        permissionStatus.photos === "prompt" ||
        permissionStatus.photos === "prompt-with-rationale"
      ) {
        const requestResult = await Camera.requestPermissions({
          permissions: ["photos"],
        });
        console.log("Permission request result:", requestResult);

        if (requestResult.photos === "denied") {
          console.error("Permission denied");
          alert("Please grant photo access permission in settings");
          return;
        }
      }

      // Use getPhoto with base64 result for single image
      // Or pickImages for multiple
      const result = await Camera.pickImages({
        quality: 80,
        limit: 4,
      });

      console.log("Images picked:", result.photos?.length);

      if (result.photos && result.photos.length > 0) {
        this.selectedCount = result.photos.length;
        let photos: string[] = [];

        for (const photo of result.photos) {
          try {
            // Use webPath and convert to base64
            const base64 = await this.getBase64FromPath(photo.webPath);
            photos.push(base64);
          } catch (e) {
            console.error("Error converting photo:", e);
          }
        }

        if (photos.length > 0) {
          await this.doUpload(photos, true);
        }
      }
    } catch (error) {
      console.error("Pick images error:", error);

      // If Camera.pickImages fails, show alert
      if (error.message && !error.message.includes("cancel")) {
        alert("Error picking images: " + error.message);
      }
    }
  }

  async getBase64FromPath(webPath: string): Promise<string> {
    try {
      const response = await fetch(webPath);
      const blob = await response.blob();

      return new Promise((resolve, reject) => {
        const reader = new FileReader();
        reader.onerror = reject;
        reader.onload = () => resolve(reader.result as string);
        reader.readAsDataURL(blob);
      });
    } catch (error) {
      console.error("Error fetching image:", error);
      throw error;
    }
  }

  async doUpload(fileOrBase64: any, isBase64: boolean = true) {
    try {
      this.isUploading = true;
      this.parseFile = [];

      console.log("Uploading", fileOrBase64.length, "files...");

      for (let i = 0; i < fileOrBase64.length; i++) {
        let img = await this.parseFileService.upload(fileOrBase64[i], isBase64);
        this.parseFile.push(img);
      }

      this.isUploading = false;
      this.eventFileUpload.emit(this.parseFile);
      console.log("Upload complete");
    } catch (error) {
      this.isUploading = false;
      console.error("Upload error:", error.message);
    }
  }
}
